import React, { useState } from "react";
import "./InfluencerHowMobile.css";

const InfluencerHowMobile = ({ steps }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className="influencerhowmobile-wrapper">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div
            className="influencerhowmobile-step-box"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="influencerhowmobile-step-number">
              {index + 1}
            </div>
            <div className="influencerhowmobile-step-icon">
              <div className="influencerhowmobile-icon-box">
                <img
                  src={hoveredIndex === index ? step.iconHover : step.icon}
                  alt={step.title}
                />
              </div>
            </div>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </div>
          {/* Vertical connector below card, except last one */}
          {index < steps.length - 1 && (
            <div className="influencerhowmobile-connector" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default InfluencerHowMobile;
